var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStarEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-star-empty",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.418,
    height: 17.541,
    viewBox: "0 0 18.418 17.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M148.9,727.924a.465.465,0,0,1-.219-.055l-5.181-2.724-5.181,2.724a.465.465,0,0,1-.5-.036.47.47,0,0,1-.187-.461l.989-5.769-4.192-4.086a.471.471,0,0,1,.261-.8l5.793-.841,2.59-5.25a.492.492,0,0,1,.845,0l2.59,5.25,5.792.841a.471.471,0,0,1,.261.8l-4.192,4.086.99,5.769a.472.472,0,0,1-.464.551Zm-13.126-10.415,3.685,3.593a.47.47,0,0,1,.136.417l-.869,5.073,4.555-2.4a.473.473,0,0,1,.438,0l4.555,2.4-.87-5.073a.473.473,0,0,1,.136-.417l3.686-3.593-5.093-.739a.474.474,0,0,1-.355-.257L143.5,711.9l-2.278,4.617a.472.472,0,0,1-.354.257Z",
    transform: "translate(-134.289 -710.383)",
    fill: "#333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarEmpty);
export default __webpack_public_path__ + "static/media/icon-star-empty.4a9a0d3a8f8c9fa89e728fd7c3cb8867.svg";
export { ForwardRef as ReactComponent };